module.exports = __webpack_public_path__ + "img/PLAY.33d0638b.svg";